import React from 'react';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';

const PhotoCarousel = (props) => {
    const { classes } = props;

    const date_options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };

    const display_taker = (taker, accountInformation) => {
        let ret = ""
        let taker_unknown = <FormattedMessage id="form.unknown" defaultMessage="Unknown" />
        if (taker === "" || typeof(taker) === "object") {
            ret = taker_unknown
        }
        else if (taker === taker_unknown || taker === accountInformation.username || (accountInformation.readOnly === false && accountInformation.anonymised_patient === false)) {
            ret = taker
        }
        return ret
    }

    return(
        <Carousel showArrows={true} selectedItem={props.selectedPicture} 
        onChange={(e) => props.handleCarrouselChange(e)}>
            {props.photo.map((photo,index)=> {
                let taker = <FormattedMessage id="form.unknown" defaultMessage="Unknown" />
                let picture_data = photo.y

                if (Utils.isValidJson(picture_data)) {
                    let obj_pic = JSON.parse(picture_data)
                    if (obj_pic.taker !== undefined) {
                        taker = display_taker(obj_pic.taker, props.accountInformation)
                }
                    if (obj_pic.imageSrc !== undefined) {
                        picture_data = obj_pic.imageSrc
                    }
                }

                if (picture_data !== undefined && picture_data[0] === '"') {
                    picture_data = picture_data.slice(1)
                }
                if (picture_data !== undefined && picture_data[picture_data.length - 1] === '"') {
                    picture_data = picture_data.slice(0, -1)
                }
                let date = new Date(photo.x)
                return (
                    <div>
                        <img key={index + photo.x} alt="" src={picture_data} />
                        {date.toLocaleDateString(props.currentLocale, date_options) + " " + date.toLocaleTimeString(props.currentLocale)}
                        <br/>
                        {taker}
                    </div>
                )
            })}
        </Carousel>
    )
};

export default withStyles(Constants.styles)(PhotoCarousel);
